import React from 'react'
import { css } from '@emotion/core'

type Props = {
  masterInHouseCosts?: any
}

export const MasterInHouseCostsList: React.FC<Props> = ({ masterInHouseCosts }) => {
  return (
    <div css={mainListContainerStyle}>
      <ul css={mainListHeaderStyle}>
        <li css={list1Style}>開始金額</li>
        <li css={list2Style}>倍率</li>
      </ul>
      <ul css={mainListContentsStyle}>
        {masterInHouseCosts.map((masterInHouseCost: any) => (
          <li key={masterInHouseCost.in_house_cost_id}>
            <div css={[listItemStyle, list1Style]}>
              <div css={overflowText}>{masterInHouseCost.begin_price}</div>
            </div>
            <div css={[listItemStyle, list2Style]}>
              <div css={overflowText}>{masterInHouseCost.competition}</div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  )
}

const mainListContainerStyle = css({
  display: 'grid',
  width: 'calc(100vw - 220px - 68px)',
  overflowY: 'hidden',
  overflowX: 'scroll',
  height: '480px',
  border: '1px solid #DDDDDD',
  boxSizing: 'border-box',
  boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.15)',
  borderRadius: '10px',
  backgroundColor: '#FFFFFF',
})

const mainListHeaderStyle = css({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  height: '60px',
  backgroundColor: '#E6E6E6',
  padding: '20px 16px',
  // スクロールバーのサイズ = 15px　ヘッダーはスクロールバーを表示しない為、横幅調整
  marginRight: '15px',
  li: {
    marginRight: '20px',
    whiteSpace: 'nowrap',
    fontSize: '13px',
  },
})

const mainListContentsStyle = css({
  width: '100%',
  height: '420px',
  overflowY: 'scroll',
  backgroundColor: '#FFFFFF',
  scrollbarWidth: 'none',
  li: {
    padding: '20px 16px',
    borderBottom: '1px solid #DDDDDD',
    display: 'flex',
    whiteSpace: 'nowrap',
    alignItems: 'center',
    fontSize: '13px',
    '&:hover': {
      backgroundColor: '#EEEEEE',
    },
  },
})

const listItemStyle = css({
  display: 'flex',
  alignItems: 'center',
  marginRight: '20px',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
})

const overflowText = css({
  textOverflow: 'ellipsis',
  overflow: 'hidden',
})

const list1Style = css({
  width: '40%',
})

const list2Style = css({
  width: '40%',
})
